var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.lazyRender)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"drawer__item",class:_vm.classes},[_vm._t("default",null,{"show":_vm.isActive})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }